import React from 'react';
import get from 'lodash/get';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

import ListResource from './ListResource.jsx';

import { env } from '~/commons/config';

const ListArticles = () => (
  <ListResource
    {...{
      searchable: true,
      api: 'api/quiz/articles',
      sort: { title: 1 },
      cols: [
        { key: 'title', sortable: true },
        {
          key: 'subjects',
          getter: (v) => v
            .map((s) => get(env.subjects, `${s}.zhhk`))
            .join(', '),
        },
        {
          key: 'attachment',
          getter(v) {
            return v ? (
              <FA icon={faCheck} />
            ) : '';
          },
        },
      ],
    }}
  />
);

export default ListArticles;
